(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-random-products]').forEach(grid=>{
  if(grid.dataset.randomized==='true')return;
  grid.dataset.randomized='true';
  const items=[...grid.querySelectorAll('[data-random-product]')];
  for(let index=items.length-1;index>0;index-=1){
    const swapIndex=Math.floor(Math.random()*(index+1));
    [items[index],items[swapIndex]]=[items[swapIndex],items[index]];
  }
  const count=Number(grid.dataset.productsToShow)||4;
  items.forEach((item,index)=>{item.hidden=index>=count;grid.append(item)});
});

document.addEventListener('submit',async event=>{
  const form=event.target.closest?.('.featured-collection__grid .product-card__ajax-form');
  if(!form)return;
  event.preventDefault();
  if(form.dataset.cartPending==='true')return;
  const button=form.querySelector('[data-card-add-button]');
  const status=form.querySelector('[data-card-add-status]');
  if(!button)return;
  const originalLabel=button.textContent;
  form.dataset.cartPending='true';
  button.disabled=true;
  button.textContent=button.dataset.addingLabel;
  if(status)status.textContent=button.dataset.addingLabel;
  try{
    const root=window.Shopify?.routes?.root||'/';
    const variantId=Number(form.querySelector('[name="id"]')?.value);
    const quantity=Number(form.querySelector('[name="quantity"]')?.value)||1;
    const response=await fetch(`${root.replace(/\/$/,'')}/cart/add.js`,{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      credentials:'same-origin',
      body:JSON.stringify({items:[{id:variantId,quantity}]})
    });
    const result=await response.json();
    if(!response.ok)throw new Error(result.description||button.dataset.errorLabel);
    button.textContent=button.dataset.addedLabel;
    if(status)status.textContent=button.dataset.addedLabel;
    document.dispatchEvent(new CustomEvent('cart:updated'));
    window.setTimeout(()=>{button.textContent=originalLabel},1000);
  }catch(error){
    const message=error.message||button.dataset.errorLabel;
    button.textContent=message;
    if(status)status.textContent=message;
    window.setTimeout(()=>{button.textContent=originalLabel},1800);
  }finally{
    form.dataset.cartPending='false';
    button.disabled=false;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    if (window.creditPopupInitialized) return;
    window.creditPopupInitialized = true;

    const setOpen = (dialog, open) => {
      const root = dialog.closest('[data-credit-popup]');
      const trigger = root?.querySelector('[data-credit-popup-open]');
      trigger?.setAttribute('aria-expanded', String(open));
    };
    const openDialog = (dialog) => {
      if (!dialog) return;
      if (dialog.open || dialog.hasAttribute('open')) {
        setOpen(dialog, true);
        return;
      }
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      setOpen(dialog, true);
    };
    const closeDialog = (dialog) => {
      if (!dialog) return;
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
      setOpen(dialog, false);
    };
    const openReviews = (button) => {
      const dialog = document.getElementById(button?.getAttribute('aria-controls'));
      if (!dialog) return;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      document.documentElement.classList.add('okendo-reviews-open');
    };
    const closeReviews = (dialog) => {
      if (!dialog) return;
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
      document.documentElement.classList.remove('okendo-reviews-open');
    };

    document.addEventListener('click', (event) => {
      const reviewsOpen = event.target.closest('[data-okendo-reviews-open]');
      if (reviewsOpen) {
        openReviews(reviewsOpen);
        return;
      }
      const reviewsClose = event.target.closest('[data-okendo-reviews-close]');
      if (reviewsClose) {
        closeReviews(reviewsClose.closest('[data-okendo-reviews-dialog]'));
        return;
      }
      const reviewsDialog = event.target.closest('[data-okendo-reviews-dialog]');
      if (reviewsDialog && event.target === reviewsDialog) {
        closeReviews(reviewsDialog);
        return;
      }
      const open = event.target.closest('[data-credit-popup-open]');
      if (open) {
        openDialog(document.getElementById(open.getAttribute('aria-controls')));
        return;
      }
      const close = event.target.closest('[data-credit-popup-close]');
      if (close) {
        closeDialog(close.closest('[data-credit-popup-dialog]'));
        return;
      }
      const dismiss = event.target.closest('[data-credit-popup-dismiss]');
      if (dismiss) {
        dismiss.closest('[data-credit-popup-launcher]').hidden = true;
        return;
      }
      const dialog = event.target.closest('[data-credit-popup-dialog]');
      if (dialog && event.target === dialog) {
        const box = dialog.getBoundingClientRect();
        const inside = event.clientX >= box.left && event.clientX <= box.right && event.clientY >= box.top && event.clientY <= box.bottom;
        if (!inside) closeDialog(dialog);
      }
    });
    document.addEventListener('close', (event) => {
      if (event.target.matches?.('[data-credit-popup-dialog]')) setOpen(event.target, false);
      if (event.target.matches?.('[data-okendo-reviews-dialog]')) document.documentElement.classList.remove('okendo-reviews-open');
    }, true);

    const openSuccess = (root = document) => {
      root.querySelectorAll('.credit-popup__success').forEach((message) => openDialog(message.closest('[data-credit-popup-dialog]')));
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => openSuccess());
    else openSuccess();
    document.addEventListener('shopify:section:load', (event) => openSuccess(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
class IpinpinCollectionQuickView{
  constructor(dialog){
    this.dialog=dialog;
    this.image=dialog.querySelector('[data-quick-view-image]');
    this.thumbs=dialog.querySelector('[data-quick-view-thumbs]');
    this.title=dialog.querySelector('[data-quick-view-title]');
    this.price=dialog.querySelector('[data-quick-view-price]');
    this.compare=dialog.querySelector('[data-quick-view-compare]');
    this.options=dialog.querySelector('[data-quick-view-options]');
    this.form=dialog.querySelector('[data-quick-view-form]');
    this.variantId=dialog.querySelector('[data-quick-view-variant-id]');
    this.submit=dialog.querySelector('[data-quick-view-submit]');
    this.status=dialog.querySelector('[data-quick-view-status]');
    this.details=dialog.querySelector('[data-quick-view-details]');
    this.description=dialog.querySelector('[data-quick-view-description]');
    this.sizeGuide=dialog.closest('[data-collection-product-grid]')?.querySelector('[data-collection-size-guide]');
    this.sizeGuideContent=this.sizeGuide?.querySelector('[data-collection-size-guide-content]');
    this.sizeGuideFallback=this.sizeGuideContent?.innerHTML||'';
    this.sizeGuideCache=new Map();
    this.sizeGuideLabel=this.sizeGuide?.getAttribute('aria-label')||'Size Guide';
    this.form.addEventListener('submit',event=>this.addToCart(event));
    this.dialog.addEventListener('click',event=>{if(event.target===this.dialog)this.dialog.close()});
    this.dialog.addEventListener('close',()=>{document.body.classList.remove('collection-quick-view-open');this.lastFocused?.focus()});
    this.sizeGuide?.querySelector('[data-collection-size-guide-close]')?.addEventListener('click',()=>this.sizeGuide.close());
    this.sizeGuide?.addEventListener('click',event=>{if(event.target===this.sizeGuide)this.sizeGuide.close()});
  }
  open(opener){
    const card=opener.closest('[data-quick-view-card]');
    const data=card?.querySelector('[data-quick-view-product]');
    if(!data)return;
    try{this.product=JSON.parse(data.textContent)}catch(error){return}
    this.lastFocused=opener;
    this.variant=this.product.variants.find(item=>item.id===this.product.initialVariantId)||this.product.variants.find(item=>item.available)||this.product.variants[0];
    this.selections=this.variant?.options?.slice()||[];
    this.render();
    document.body.classList.add('collection-quick-view-open');
    if(typeof this.dialog.showModal==='function')this.dialog.showModal();else this.dialog.setAttribute('open','');
  }
  render(){
    this.title.textContent=this.product.title;
    this.description.textContent=this.product.description;
    this.details.href=this.product.url;
    this.status.textContent='';
    this.renderGallery();
    this.renderOptions();
    this.updateVariant();
  }
  renderGallery(){
    this.thumbs.replaceChildren();
    const images=this.product.images||[];
    images.forEach((url,index)=>{
      const button=document.createElement('button');
      const image=document.createElement('img');
      button.type='button';
      button.className='collection-quick-view__thumb';
      button.setAttribute('aria-label',`${this.product.title} ${index+1}`);
      image.src=url;
      image.alt='';
      image.loading='lazy';
      button.append(image);
      button.addEventListener('click',()=>this.selectImage(url,index));
      this.thumbs.append(button);
    });
    this.selectImage(images[0]||'',0);
  }
  selectImage(url,index){
    if(url){this.image.src=url;this.image.alt=this.product.title}else{this.image.removeAttribute('src');this.image.alt=''}
    [...this.thumbs.children].forEach((button,itemIndex)=>button.classList.toggle('is-active',itemIndex===index));
  }
  renderOptions(){
    this.options.replaceChildren();
    if(this.product.hasOnlyDefaultVariant)return;
    (this.product.options||[]).forEach((option,optionIndex)=>{
      const fieldset=document.createElement('fieldset');
      const legend=document.createElement('legend');
      const heading=document.createElement('div');
      const values=document.createElement('div');
      heading.className='collection-quick-view__option-heading';
      values.className='collection-quick-view__values';
      legend.textContent=`${option.name}: ${this.selections[optionIndex]||''}`;
      heading.append(legend);
      if(this.sizeGuide&&/(size|尺码)/i.test(option.name)){
        const guideButton=document.createElement('button');
        guideButton.type='button';
        guideButton.className='collection-quick-view__size-guide';
        guideButton.textContent=this.sizeGuideLabel;
        guideButton.addEventListener('click',()=>this.openSizeGuide());
        heading.append(guideButton);
      }
      option.values.forEach(value=>{
        const button=document.createElement('button');
        button.type='button';
        button.className='collection-quick-view__value';
        button.textContent=value;
        button.classList.toggle('is-active',this.selections[optionIndex]===value);
        button.disabled=!this.product.variants.some(variant=>variant.available&&variant.options[optionIndex]===value);
        button.addEventListener('click',()=>this.selectOption(optionIndex,value));
        values.append(button);
      });
      fieldset.append(heading,values);
      this.options.append(fieldset);
    });
  }
  selectOption(optionIndex,value){
    this.selections[optionIndex]=value;
    let variant=this.product.variants.find(item=>item.options.every((option,index)=>option===this.selections[index]));
    if(!variant?.available){
      variant=this.product.variants.find(item=>item.available&&item.options[optionIndex]===value)||variant;
      if(variant)this.selections=variant.options.slice();
    }
    this.variant=variant;
    this.renderOptions();
    this.updateVariant();
  }
  updateVariant(){
    const variant=this.variant;
    if(!variant)return;
    this.variantId.value=variant.id;
    this.price.textContent=variant.priceText;
    const onSale=Number(variant.compareAt)>Number(variant.price);
    this.compare.hidden=!onSale;
    this.compare.textContent=onSale?variant.compareAtText:'';
    this.submit.disabled=!variant.available;
    this.submit.textContent=variant.available?this.dialog.dataset.addLabel:this.dialog.dataset.soldLabel;
    if(variant.featuredImage){
      const index=(this.product.images||[]).indexOf(variant.featuredImage);
      this.selectImage(variant.featuredImage,index>=0?index:0);
    }
  }
  async openSizeGuide(){
    if(!this.sizeGuide||!this.sizeGuideContent||!this.product?.url)return;
    const productUrl=this.product.url;
    this.sizeGuideContent.classList.add('is-loading');
    this.sizeGuideContent.setAttribute('aria-busy','true');
    if(typeof this.sizeGuide.showModal==='function')this.sizeGuide.showModal();else this.sizeGuide.setAttribute('open','');
    try{
      const content=await this.loadSizeGuide(productUrl);
      if(this.product?.url===productUrl)this.sizeGuideContent.innerHTML=content;
    }finally{
      this.sizeGuideContent.classList.remove('is-loading');
      this.sizeGuideContent.removeAttribute('aria-busy');
    }
  }
  async loadSizeGuide(productUrl){
    if(this.sizeGuideCache.has(productUrl))return this.sizeGuideCache.get(productUrl);
    try{
      const response=await fetch(productUrl,{headers:{Accept:'text/html'},credentials:'same-origin'});
      if(!response.ok)throw new Error(String(response.status));
      const page=new DOMParser().parseFromString(await response.text(),'text/html');
      const content=page.querySelector('[data-size-guide-dialog] .size-guide__content');
      const image=page.querySelector('[data-size-guide-dialog] .size-guide__panel > img');
      const markup=content?.innerHTML.trim()||image?.outerHTML||this.sizeGuideFallback;
      this.sizeGuideCache.set(productUrl,markup);
      return markup;
    }catch(error){
      return this.sizeGuideFallback;
    }
  }
  async addToCart(event){
    event.preventDefault();
    if(!this.variant?.available)return;
    this.submit.disabled=true;
    this.submit.textContent=this.dialog.dataset.addingLabel;
    this.status.textContent='';
    try{
      const root=window.Shopify?.routes?.root||'/';
      const response=await fetch(`${root.replace(/\/$/,'')}/cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items:[{id:this.variant.id,quantity:1}]})});
      const result=await response.json();
      if(!response.ok)throw new Error(result.description||this.dialog.dataset.errorLabel);
      this.status.textContent=this.dialog.dataset.addedLabel;
      this.dialog.close();
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
    }catch(error){
      this.status.textContent=error.message||this.dialog.dataset.errorLabel;
      this.submit.disabled=false;
      this.submit.textContent=this.dialog.dataset.addLabel;
    }
  }
}
document.addEventListener('click',event=>{
  const opener=event.target.closest('[data-quick-view-open]');
  if(!opener)return;
  const section=opener.closest('[data-collection-product-grid]');
  const dialog=section?.querySelector('[data-collection-quick-view]');
  if(!dialog)return;
  if(!dialog.quickView)dialog.quickView=new IpinpinCollectionQuickView(dialog);
  dialog.quickView.open(opener);
});
document.addEventListener('submit',async event=>{
  const form=event.target.closest?.('.product-card__ajax-form');
  if(!form||!form.closest('[data-collection-product-grid]'))return;
  event.preventDefault();
  const card=form.closest('.product-card');
  const button=form.querySelector('[data-card-add-button]');
  const status=form.querySelector('[data-card-add-status]');
  const check=card?.querySelector('[data-card-added-check]');
  const originalLabel=button?.textContent||'';
  if(!button||button.disabled)return;
  button.disabled=true;
  button.textContent=button.dataset.addingLabel;
  if(status)status.textContent=button.dataset.addingLabel;
  try{
    const root=window.Shopify?.routes?.root||'/';
    const variantId=Number(form.querySelector('[name="id"]')?.value);
    const quantity=Number(form.querySelector('[name="quantity"]')?.value)||1;
    const response=await fetch(`${root.replace(/\/$/,'')}/cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items:[{id:variantId,quantity}]})});
    const result=await response.json();
    if(!response.ok)throw new Error(result.description||button.dataset.errorLabel);
    card?.classList.add('is-added');
    if(check)check.hidden=false;
    if(status)status.textContent=button.dataset.addedLabel;
    button.textContent=originalLabel;
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }catch(error){
    const message=error.message||button.dataset.errorLabel;
    if(status)status.textContent=message;
    button.textContent=message;
    window.setTimeout(()=>{button.textContent=originalLabel},1800);
  }finally{
    button.disabled=false;
  }
});

  } catch(e) { console.error(e); }
})();
})();
